import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressFormModel } from '@shared/models/forms/address-form.model';
import { Bundesland, Country } from '@backend/models';

export function createAddressForm(): FormGroup<AddressFormModel> {
  return new FormGroup<AddressFormModel>({
    street: new FormControl<string | null>(null, [Validators.required]),
    houseNumber: new FormControl<string | null>(null, [Validators.required]),
    zip: new FormControl<string | null>(null, [Validators.required]),
    city: new FormControl<string | null>(null, [Validators.required]),
    country: new FormControl<Country | null>(null, [Validators.required]),
    // Bundesland is required only when the country is Austria; toggled in AddressDataComponent.
    bundesland: new FormControl<Bundesland | null>(null)
  });
}
